'use client';

import {Icon} from '@udemy-v2/icons';
import {useI18n} from '@udemy-v2/i18n';
import {Button} from '@udemy-v2/react-core-components';

import styles from './course-limited-access.module.scss';
import {OnePaneLayoutContainer} from '@udemy-v2/react-layout-components';

interface CourseLimitedAccessProps {
    buttonLabel: string;
    onButtonClick: () => void;
    buttonDisabled?: boolean;
    children?: React.ReactNode;
}

export function CourseLimitedAccess({
    buttonLabel,
    onButtonClick,
    buttonDisabled,
    children,
}: CourseLimitedAccessProps) {
    const {gettext} = useI18n();

    return (
        <OnePaneLayoutContainer>
            <h1 className={`ud-heading-xl ${styles['heading']}`}>
                {gettext('This is a private course.')}
            </h1>
            <Button udStyle="primary" disabled={buttonDisabled} onClick={onButtonClick}>
                <Icon glyph="lock" label={false} size="xsmall" />
                {buttonLabel}
            </Button>
            {children}
        </OnePaneLayoutContainer>
    );
}
